/**
 * Legal Document Version Constants
 * 
 * These constants track the current version of legal documents.
 * When updating Terms of Service or Privacy Policy, increment the version number.
 * This allows tracking which version each user accepted for legal compliance.
 */

export const LEGAL_VERSIONS = {
  TERMS: '1.2.0',
  PRIVACY: '1.3.0',
} as const;

/**
 * Get the current Terms of Service version
 */
export function getTermsVersion(): string {
  return LEGAL_VERSIONS.TERMS;
}

/**
 * Get the current Privacy Policy version
 */
export function getPrivacyVersion(): string {
  return LEGAL_VERSIONS.PRIVACY;
}
